import React, { useEffect, useState } from "react";
import { FloatInput } from "../Floating";
import { useDispatch, useSelector } from "react-redux";
import { getOffersList } from "../../appRedux/actions/offers";

function Filter({ initialFetchComplete, searchText, setSearchText }) {
  const dispatch = useDispatch();
  const { queryInfo } = useSelector((state) => ({
    queryInfo: state.offers.queryInfo,
  }));

  useEffect(() => {
    if (!initialFetchComplete) return;
    const timeout = setTimeout(() => {
      dispatch(
        getOffersList({
          ...queryInfo,
          search: searchText || undefined,
          page: 1,
        })
      );
    }, 500);
    return () => clearTimeout(timeout);
  }, [searchText]);

  return (
    <div className="row filter-row" style={{ marginBottom: "20px" }}>
      <div className="col-sm-12 col-md-8 pb-2">
        <FloatInput
          label="Search by title or description..."
          value={searchText}
          name="searchText"
          id="offerSearch"
          onChange={(e) => setSearchText(e.target.value)}
        />
      </div>
      <div className="col-sm-12 col-md-4 pb-2 d-flex justify-content-md-end align-items-center">
        <button
          className="btn btn-outline-danger"
          style={{ height: "46px", padding: "0 20px", display: "flex", alignItems: "center", gap: "8px", borderRadius: "6px" }}
          onClick={() => setSearchText("")}
          disabled={!searchText}
        >
          <i className="fa fa-times" /> Clear Form
        </button>
      </div>
    </div>
  );
}

export default Filter;
